import React from 'react';

export default function ApplicationAssessmentsInstructions() {

  return (
    <div className='expanded-accordion-content explanation-of-wahve'>
      <div className='callout'><b>Instructions:</b></div>
      <div className='callout'>There are a number of parts to the interview. Each section has a script to guide you through the interview.</div>
      <div className='callout'><b>Overview:</b></div>
      <div className='callout'>
        <ol className='instructions-list'>
          <li className='instructions-list-item'>Preferences (Availability, Work Objectives, Home Office Setup)</li>
          <li className='instructions-list-item'>Assessments</li>
          <li className='instructions-list-item'>Work Experience</li>
          <li className='instructions-list-item'>Skills</li>
          <li className='instructions-list-item'>Background (Licenses, Designations, Medicare & Social Security)</li>
          <li className='instructions-list-item'>Behavioral Questions</li>
          <li className='instructions-list-item'>Completion of Interview (Status Determination and Interview Conclusion)</li>
          <li className='instructions-list-item'>Rating of Applicant</li>
        </ol>
      </div>
      <div className='callout'>Make sure to view your application review notes in each section throughout the interview and add any additional notes. Please be as detailed as possible in your interview notes as they are very important in determining the best match for the applicant.</div>
    </div>
  );

}



// WEBPACK FOOTER //
// ./shared/react/r_ExpandedCard/Steps/Interview/f_ApplicationAssessmentsInstructions/index.js